import createIcon from '../../createIcon';

/**
 * @component @name MicExternalOn
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOS4yMiA3SDQuNzhDNC4zIDYuNDcgNCA1Ljc3IDQgNUM0IDMuMzQgNS4zNCAyIDcgMkM4LjY2IDIgMTAgMy4zNCAxMCA1QzEwIDUuNzcgOS43IDYuNDcgOS4yMiA3Wk0xNiAyQzE4LjIxIDIgMjAgMy43OSAyMCA2VjIySDE4VjZDMTggNC45IDE3LjEgNCAxNiA0QzE0LjkgNCAxNCA0LjkgMTQgNlYxOEMxNCAyMC4yMSAxMi4yMSAyMiAxMCAyMkM3Ljc5IDIyIDYgMjAuMjEgNiAxOEg1TDQgOEgxMEw5IDE4SDhDOCAxOS4xIDguOSAyMCAxMCAyMEMxMS4xIDIwIDEyIDE5LjEgMTIgMThWNkMxMiAzLjc5IDEzLjc5IDIgMTYgMloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const MicExternalOn = createIcon('MicExternalOn', [
  [
    'path',
    {
      d: 'M9.22 7H4.78C4.3 6.47 4 5.77 4 5C4 3.34 5.34 2 7 2C8.66 2 10 3.34 10 5C10 5.77 9.7 6.47 9.22 7ZM16 2C18.21 2 20 3.79 20 6V22H18V6C18 4.9 17.1 4 16 4C14.9 4 14 4.9 14 6V18C14 20.21 12.21 22 10 22C7.79 22 6 20.21 6 18H5L4 8H10L9 18H8C8 19.1 8.9 20 10 20C11.1 20 12 19.1 12 18V6C12 3.79 13.79 2 16 2Z',
      key: 'ck4ns',
    },
  ],
]);

export default MicExternalOn;
